export const CUSTOMER_LOAD = "customer.load";
export const CUSTOMER_CLEAR = "customer.clear";
export const CUSTOMER_EDIT = "customer.edit";
export const CUSTOMER_PASSWORD_CHANGE = "customer.password.change";
